/* tslint:disable */
/* eslint-disable */
/**
 * Project Client API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const QuoteAcceptanceBlockingReason = {
    FreelancerVerification: 'FREELANCER_VERIFICATION',
    QuoteNotPending: 'QUOTE_NOT_PENDING',
    AdministratorValidationRequired: 'ADMINISTRATOR_VALIDATION_REQUIRED',
    NotParticipant: 'NOT_PARTICIPANT',
    AcceptanceRoleRequired: 'ACCEPTANCE_ROLE_REQUIRED'
} as const;
export type QuoteAcceptanceBlockingReason = typeof QuoteAcceptanceBlockingReason[keyof typeof QuoteAcceptanceBlockingReason];


export function instanceOfQuoteAcceptanceBlockingReason(value: any): boolean {
    for (const key in QuoteAcceptanceBlockingReason) {
        if (Object.prototype.hasOwnProperty.call(QuoteAcceptanceBlockingReason, key)) {
            // @ts-ignore
            if (QuoteAcceptanceBlockingReason[key] === value) {
                return true;
            }
        }
    }
    return false;
}

export function QuoteAcceptanceBlockingReasonFromJSON(json: any): QuoteAcceptanceBlockingReason {
    return QuoteAcceptanceBlockingReasonFromJSONTyped(json, false);
}

export function QuoteAcceptanceBlockingReasonFromJSONTyped(json: any, ignoreDiscriminator: boolean): QuoteAcceptanceBlockingReason {
    return json as QuoteAcceptanceBlockingReason;
}

export function QuoteAcceptanceBlockingReasonToJSON(value?: QuoteAcceptanceBlockingReason | null): any {
    return value as any;
}

